import { render, staticRenderFns } from "./loginBox.vue?vue&type=template&id=7a5544fe&"
import script from "./loginBox.vue?vue&type=script&lang=js&"
export * from "./loginBox.vue?vue&type=script&lang=js&"
import style0 from "./loginBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports